import React from 'react';
import { useNavigate } from 'react-router-dom';

const cor = '#B51013';

export default function AcessoNegado() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', fontFamily: 'Arial, sans-serif', background: '#f5f5f5',
    }}>
      <div style={{
        background: '#fff', borderRadius: '12px', padding: '40px',
        maxWidth: '420px', width: '100%', textAlign: 'center',
        border: '1px solid #e5e5e5', boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
      }}>
        <div style={{
          width: '56px', height: '56px', borderRadius: '50%', background: '#FCEBEB',
          display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px',
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke={cor} strokeWidth="1.5" />
            <path d="M8 8l8 8M16 8l-8 8" stroke={cor} strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </div>
        <div style={{ fontSize: '16px', fontWeight: '700', color: '#1a1a1a', marginBottom: '8px' }}>
          Acesso negado
        </div>
        <div style={{ fontSize: '13px', color: '#888', marginBottom: '24px', lineHeight: '1.5' }}>
          Você não tem permissão para acessar esta área.
          Entre em contato com o administrador caso precise de acesso.
        </div>
        <button
          onClick={() => navigate('/dashboard')}
          style={{
            padding: '9px 24px', background: cor, color: '#fff', border: 'none',
            borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer',
          }}
        >
          Voltar ao início
        </button>
      </div>
    </div>
  );
}
